{
  "name": "datasmart",
  "version": "5.1.18",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:test": "ng serve --configuration=test",
    "start:local": "ng serve --configuration=local",
    "start:local-test": "ng serve --configuration=local-test",
    "start:local-prod": "ng serve --configuration=local-prod",
    "start:client": "node scripts/run-client.mjs serve",
    "start:client-test": "node scripts/run-client.mjs serve test",
    "start:client-prod": "node scripts/run-client.mjs serve prod",
    "build": "ng build",
    "build:prod": "ng build --configuration=production",
    "build:prod:stats": "ng build --configuration=production --stats-json",
    "build:test": "ng build --configuration=test",
    "build:local": "ng build --configuration=development,local",
    "build:local-test": "ng build --configuration=test,local-test",
    "build:local-prod": "ng build --configuration=production,local-prod",
    "build:client": "node scripts/run-client.mjs build",
    "build:client-test": "node scripts/run-client.mjs build test",
    "client:use": "node scripts/run-client.mjs use",
    "client:show": "node scripts/run-client.mjs show",
    "watch": "ng build --watch --configuration=development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.5",
    "@angular/cdk": "^22.1.5",
    "@angular/common": "^22.1.5",
    "@angular/compiler": "^22.1.5",
    "@angular/core": "^22.1.5",
    "@angular/forms": "^22.1.5",
    "@angular/google-maps": "^22.1.5",
    "@angular/localize": "^22.1.5",
    "@angular/platform-browser": "^22.1.5",
    "@angular/platform-browser-dynamic": "^22.1.5",
    "@angular/router": "^22.1.5",
    "@capacitor/app": "^8.1.1",
    "@capacitor/cli": "^8.5.1",
    "@capacitor/core": "^8.5.1",
    "@capacitor/haptics": "8.0.2",
    "@capacitor/keyboard": "8.0.5",
    "@capacitor/status-bar": "^8.0.3",
    "@fullcalendar/angular": "^6.1.21",
    "@fullcalendar/core": "^6.1.21",
    "@fullcalendar/daygrid": "^6.1.21",
    "@fullcalendar/interaction": "^6.1.21",
    "@fullcalendar/list": "^6.1.21",
    "@fullcalendar/timegrid": "^6.1.21",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@ng-select/ng-select": "^24.1.1",
    "@ngx-translate/core": "^18.0.0",
    "@paypal/paypal-js": "^11.0.0",
    "@popperjs/core": "^2.11.8",
    "@primeuix/themes": "^3.0.0",
    "@tiptap/core": "^3.31.3",
    "@tiptap/extension-image": "^3.31.3",
    "@tiptap/extension-link": "^3.31.3",
    "@tiptap/extension-table": "^3.31.3",
    "@tiptap/extension-table-cell": "^3.31.3",
    "@tiptap/extension-table-header": "^3.31.3",
    "@tiptap/extension-table-row": "^3.31.3",
    "@tiptap/extension-text-align": "^3.31.3",
    "@tiptap/extension-underline": "^3.31.3",
    "@tiptap/pm": "^3.31.3",
    "@tiptap/starter-kit": "^3.31.3",
    "@types/google.maps": "^3.66.2",
    "angularx-qrcode": "^22.0.1",
    "bootstrap": "^5.3.6",
    "chart.js": "^4.5.1",
    "lz-string": "^1.5.0",
    "mammoth": "^1.12.2",
    "ng-chartjs": "^0.2.8",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-bootstrap": "^22.0.0",
    "ngx-spinner": "^22.0.1",
    "normalize-url": "^9.0.1",
    "primeicons": "8.0.0",
    "primeng": "^22.1.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "url": "^0.11.4",
    "zone.js": "^0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.7",
    "@angular/build": "^22.1.7",
    "@angular/cli": "^22.1.7",
    "@angular/compiler-cli": "^22.1.5",
    "@types/jasmine": "~6.0.0",
    "@types/jsdom": "^30.0.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~7.0.2",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.3.0",
    "typescript": "~6.0.3"
  },
  "volta": {
    "node": "22.23.1"
  }
}
